import React, { useState, MouseEvent } from 'react'
import Popper from '@mui/material/Popper'
import Fade from '@mui/material/Fade'

import * as S from './styles'

export interface ContentTooltipProps {
  title?: string | React.ReactNode
  content: string | React.ReactNode
}

export const ContentTooltip: React.FC<ContentTooltipProps> = ({
  title,
  content,
  children
}) => {
  const [open, setOpen] = useState(false)
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)

  const toggleVisibility = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
    setOpen((previousOpen) => !previousOpen)
  }

  const canBeOpen = open && Boolean(anchorEl)
  const id = canBeOpen ? 'transition-popper' : undefined

  return (
    <div
      aria-describedby={id}
      onMouseEnter={toggleVisibility}
      onMouseLeave={toggleVisibility}
    >
      <span>{children}</span>

      <Popper
        id={id}
        open={open}
        anchorEl={anchorEl}
        style={{ zIndex: 15 }}
        placement="top"
        transition
      >
        {({ TransitionProps }) => (
          <Fade {...TransitionProps} timeout={350}>
            <S.TooltipWrapper>
              {title && <S.TitleRow>{title}</S.TitleRow>}
              <S.ContentWrapper>{content}</S.ContentWrapper>
            </S.TooltipWrapper>
          </Fade>
        )}
      </Popper>
    </div>
  )
}
